import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import moment from "moment";
import Swal from "sweetalert2";
import api from "../../api/axios";

const ReturnAssetModal = ({
  isVisible,
  onClose,
  asset,
  employeeId,
  onAssetReturned,
}) => {
  const [returnDate, setReturnDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleReturnDateChange = (e) => {
    setReturnDate(e.target.value);
    if (moment(e.target.value).isBefore(moment(asset.assigned_date))) {
      setError("Return date cannot be earlier than the assigned date.");
    } else {
      setError("");
    }
  };

  const handleReturnAsset = () => {
    setLoading(true);
    api
      .put(`return-asset/${asset.id}`, {
        return_date: moment(returnDate).format("YYYY-MM-DD"),
        updated_by: employeeId,
      })
      .then((res) => {
        onClose();
        Swal.fire({
          title: "Success",
          text: "Asset taken back successfully.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          onAssetReturned();
        });
      })
      .catch((err) => {
        console.error(err);
        onClose();
        Swal.fire({
          title: "Warning",
          text: "Failed to return asset. Please try again.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={isVisible} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Asset Return</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Please confirm the return of this asset by the employee and select the
          return date.
        </p>

        <Form>
          <Form.Group controlId="returnDate">
            <Form.Label>Return Date:</Form.Label>
            <Form.Control
              type="date"
              value={returnDate}
              onChange={handleReturnDateChange}
              min={
                asset ? moment(asset.assigned_date).format("YYYY-MM-DD") : ""
              }
            />
            {error && <Form.Text className="text-danger">* {error}</Form.Text>}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        {/* Add loading claass so loader show */}
        <Button
          variant="primary"
          onClick={handleReturnAsset}
          disabled={!returnDate || loading || error}
        >
          {loading ? "Confirming..." : "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReturnAssetModal;
